module.exports = __webpack_public_path__ + "img/jcb.24576fc9.svg";